export class FindIdAndPasswordTab {
  static ID = new FindIdAndPasswordTab("ID");
  static PASSWORD = new FindIdAndPasswordTab("PASSWORD");

  private constructor(private value: string) {}

  isId(): boolean {
    return this === FindIdAndPasswordTab.ID;
  }

  isPassword(): boolean {
    return this === FindIdAndPasswordTab.PASSWORD;
  }
}
